<template>
  <div class="row">
    <!--div class="col-sm-4 col-md-3 col-lg-2">
      <ChannelNav />
    </div-->
    <div class="col-12" XXclass="col-sm-8 col-md-9 col-lg-10">
      <div class="row">
        <div class="col-sm-9">
          <p class="float-right" v-if="showSpectrumLink">
            <a class="btn btn-dark" :href="spectrumCtaUrl">
              <img src="../assets/spectrum-logo-light.png" style="height:32px">
              <br><small>{{spectrumCtaText}}</small>
            </a>
          </p>
          <h2 class="text-left">{{broadcast.name}}</h2>
          <div class="clearfix"></div>
          <!-- Broadcast -->

          <b-alert v-if="loading" variant="info" show>Loading Broadcast...</b-alert>

          <div id="boxcast-container" ref="boxcastContainerEl" style="margin-bottom:30px">
          </div>

          <div id="inline-share-buttons" class="sharethis-inline-share-buttons" style="margin-bottom:30px"></div>

          <p v-if="showSpectrumLink">
            <a :href="spectrumCtaUrl">
              <strong>{{spectrumCtaText}}</strong>
            </a>
          </p>
        </div>
        <div class="col-sm-3 related-broadcasts">
          <!--
          <h3>Broadcast Information</h3>
          {{broadcast.starts_at}}
          -->

          <h4 class="ellipse text-left">Related Broadcasts</h4>
          <div class="row">
            <div class="col-6 col-sm-12"
                  v-for="b in relatedBroadcasts"
                  v-if="b.id != broadcast.id"
                  :key="b.id">
              <BroadcastCard :broadcast="b" :channelId="channelId" />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BoxCastAPI from '@/services/BoxCastAPI'

export default {
  name: 'ChannelListView',
  data () {
    return {
      accountChannelId: BoxCastAPI.getAccountChannelId(),
      loading: false,
      relatedBroadcasts: [],
      broadcast: {},
      channelName: '',
      spectrumCtaText: 'Spectrum Customers Click Here to Watch (available in Tampa and Orlando areas)',
      spectrumCtaUrl: 'https://www.baynews9.com/fl/tampa/sports/high-school/watch-live'
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.$refs.boxcastContainerEl) {
      // eslint-disable-next-line
      this.context = boxcast(`#${this.$refs.boxcastContainerEl.id}`)
      this.initChannelId()
      this.getBroadcast()
      this.initShare()
    } else {
      console.warn('Unable to find ref to boxcastContainerEl', this.$refs)
    }
  },
  destroyed () {
    this.context.unload()
  },
  watch: {
    '$route' (to, from) {
      this.initChannelId()
      this.getBroadcast()
      this.initShare()
      window.scrollTo(0, 0)
    }
  },
  computed: {
    showSpectrumLink () {
      const tags = this.broadcast.tags || []
      return tags.includes('spectrum-app')
    }
  },
  methods: {
    initShare () {
      try {
        window.__sharethis__.load('inline-share-buttons', {
          id: 'inline-share-buttons',
          enabled: true,
          url: window.location.href,
          alignment: 'center',
          font_size: 12,
          has_spacing: true,
          labels: 'cta',
          langauge: 'en',
          min_count: 10,
          networks: ['facebook', 'twitter', 'email', 'sms'],
          num_networks: 4,
          padding: 10,
          radius: 4,
          show_total: true,
          size: 40,
          size_label: 'medium',
          spacing: 8,
          use_native_counts: true
        })
      } catch (e) {
        console.error('unable to load share buttons', e)
      }
    },
    initChannelId () {
      if (this.$route && this.$route.query && this.$route.query.channel_id) {
        this.channelId = this.$route.query.channel_id
      } else {
        this.channelId = ''
      }
    },
    getBroadcast () {
      this.broadcast = {}

      let channelId = this.channelId
      if (!channelId || channelId === 'live_recent' || channelId === 'upcoming') {
        console.log('Coercing special channel to account-level query', channelId)
        channelId = this.accountChannelId
      }

      this.context.loadChannel(channelId, {
        disableRedirectRulesOnLoad: true,
        selectedBroadcastId: this.$route.params.broadcast_id,
        onLoadBroadcast: (b) => {
          this.broadcast = b
          this.loading = false

          // XXX:
          // eslint-disable-next-line
          this.relatedBroadcasts = boxcast.model.PlaylistStore.broadcasts
          // eslint-disable-next-line
          this.channelName = boxcast.model.CurrentChannelStore.name
        },
        showTitle: true,
        showDescription: true,
        showRelated: false,
        showCountdown: true
      })
    }
  }
}
</script>

<style>
.container[data-container] {
  max-width: 100%;
}
.related-broadcasts > h4 {
  text-align: left;
  font-size: 12pt;
  text-transform: uppercase;
  opacity: 0.6;
}
.boxcast-boxoffice h1.boxcast-title {
  font-size: 18pt;
}
.boxcast-boxoffice p.boxcast-description {
  font-size: 14pt;
  line-height: 1.2em;
}
</style>



// WEBPACK FOOTER //
// src/components/BroadcastView.vue